import { usersAvatar, UsersAvatarProps } from "@/services/users-avatar";
import { useToast } from "@/hooks/use-toast";

export const useAPIUsersAvatar = () => {
  const { showToastByCode } = useToast();

  const handleAPIUsersAvatar = async (params: UsersAvatarProps) => {
    try {
      const res = await usersAvatar(params);
      return res;
    } catch (error) {
      showToastByCode(error);
      throw error;
    }
  };

  return {
    handleAPIUsersAvatar,
  };
};
